import { MAX_PATCH_CHARS } from '../types.js';

export function truncatePatch(s: string): string {
  if (s.length <= MAX_PATCH_CHARS) return s;
  return `${s.slice(0, MAX_PATCH_CHARS)}\n\n… (diff truncated)`;
}
